export const UserIcon = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <path id="Caminho_276" data-name="Caminho 276" d="M11,11A3.5,3.5,0,1,0,7.5,7.5,3.5,3.5,0,0,0,11,11Zm0,1.75c-2.336,0-7,1.173-7,3.5V18H18V16.25C18,13.923,13.336,12.75,11,12.75Z" transform="translate(-4 -4)" fill="#2d2d2d"/>
      </svg>
    )
}